import React from 'react';
import './ScheduleCellText.less';

export const ScheduleCellText = ({text}) => {
	return <span className="schedule-cell-text">{text}</span>
}
